var render = function render(){var _vm=this,_c=_vm._self._c;return _c('full-page',{attrs:{"title":"Open Tables"}},[_c('AllTables')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }